import { render, staticRenderFns } from "./MessageMain.vue?vue&type=template&id=61b8a4e5&scoped=true&"
import script from "./MessageMain.vue?vue&type=script&lang=js&"
export * from "./MessageMain.vue?vue&type=script&lang=js&"
import style0 from "./MessageMain.vue?vue&type=style&index=0&id=61b8a4e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b8a4e5",
  null
  
)

export default component.exports